import { render } from "./clientHistory.vue?vue&type=template&id=207c0fc2"
import script from "./clientHistory.vue?vue&type=script&lang=js"
export * from "./clientHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__